import { render, staticRenderFns } from "./ReturnPaymentPlanRecordsExtends.vue?vue&type=template&id=7217b60c"
import script from "./ReturnPaymentPlanRecordsExtends.vue?vue&type=script&lang=js"
export * from "./ReturnPaymentPlanRecordsExtends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports